import React, { useEffect, useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import provinces from "@doncicuto/es-provinces";
import Boton from '../eventos/Boton';
import Accordion from 'react-bootstrap/Accordion';
import { ErrorForm } from '../eventos/Alerta';
import { handleChangeErrors, handleSubmitErrors, todosDatosCorrectos } from '../../validacion/ValidacionForm';
import { DatosCorrectos, PlazasAgotadas, ServerErrorEnvioForm, DatosIncorrectos } from '../eventos/VentanaEmergente';
import ReCAPTCHA from "react-google-recaptcha";
import { fetchCatcha, fetchCrearCurso } from '../../../peticiones_API/Penticiones_EnvioForm';
// const navigate = useNavigate();


//Formulario principal del curso
const FormCurso = ({ curso }) => {
    const recaptchaRef = useRef(null);
    const [submitRealizado, setSubmitRealizado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);


    //Creo un array de objetos que guadará los datos obligatorios en todos los forumarios de los cursos
    const [formData, setFormData] = useState({
        nombre: '',
        correo: '',
        telefono: '',
        provincia: '',
        situacionLaboral: '',
        comoNosConociste: '',
        aceptaPoliticaPrivacidad: '',

    });
    const [mensajeError, setMensajeError] = useState('');

    //Si los campos estan vacios en cualquiera de las categorias disponibles se le asiganará su mensaje de error correspondiente
    const camposRequeridos = {
        nombre: "Debes insertar un nombre",
        correo: "Debes insertar un correo",
        telefono: "Debes insertar un teléfono",
        provincia: "Debes seleccionar una provincia",
        situacionLaboral: "Debes seleccionar tu situación laboral",
        comoNosConociste: "Debes seleccionar cómo nos has conocido",
        aceptaPoliticaPrivacidad: "Debes aceptar la política de privacidad",
        captcha: "Debes completar el CAPTCHA"

    };



    //Controlaremos el estado de los alerts de los campos requeriods si esta el estado a true se activará la alerta correspondiente
    //Estos estados se complementan con los mensajes de error vistos anteriormente
    const [estadoCampoReque, setEstadoCampoReque] = useState({
        nombre: false,
        correo: false,
        telefono: false,
        provincia: false,
        situacionLaboral: false,
        comoNosConociste: false,
        aceptaPoliticaPrivacidad: false,
        captcha: false
    });

    //Estos estados arán referencia a los casos en los que un dato seá sintacticamente erroneo 
    // Es decir, que un correo no cumpla con la estrutura de correo o un telefóno no se componga de 9 digitos
    const [estadoCampoSintaxis, setestadoCampoSintaxis] = useState({
        correoMal: false,
        telefonoMal: false
    });

    let [formCompletado, setFormCompletado] = useState(null);
    let [respuestaRespt, setRespuestaRespt] = useState(null);
    let [primerEnvio, setPrimerEnvio] = useState(false);

    const [captchaToken, setCaptchaToken] = useState(null);


    const handleChange = (event, nometoken = null) => {
        //if(submitRealizado) setSubmitRealizado(false);
        //Recogemos todos los eventos y carateritícas de todos los campos a rellenar
        //Los valores no definidos en los imports de defecto como los files se añadirán posteriormente como nuevo valor
        //En el caso de los checkbox al tener la propiedad checked tambien los trataremos de forma aislada
        //Segun vallamos rellenando el formulario los cambios se guadarán en el formdata

        if (nometoken == null && event?.target !== undefined && event?.target !== null) {
            setFormCompletado(null);
            const { name, value, type, files, checked } = event.target;
            const newValue = type === 'file' ? files[0] : (type === 'checkbox' ? checked : value);
            setFormData({ ...formData, [name]: newValue });

            if (name in estadoCampoReque) {
                handleChangeErrors(name, value, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque, setestadoCampoSintaxis, setEstadosActualizados, primerEnvio);
            }

        }
        console.log("captchaToken ", nometoken);
        if (nometoken !== null) {
            setEstadoCampoReque(prevState => ({ ...prevState, captcha: false }));
            setEstadosActualizados(true);
        }

    };




    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            handleSubmitErrors(curso, camposRequeridos, formData, estadoCampoReque, estadoCampoSintaxis, setEstadoCampoReque, setestadoCampoSintaxis, setEstadosActualizados);

            if (!captchaToken) {
                setEstadoCampoReque(prevState => ({ ...prevState, captcha: true }));
                setEstadosActualizados(true);
                setPrimerEnvio(true);
                setSubmitRealizado(true);
                return;
            } else {
                setEstadoCampoReque(prevState => ({ ...prevState, captcha: false }));
                setEstadosActualizados(true);
            }

            setPrimerEnvio(true);
            setSubmitRealizado(true);
        } catch (error) {
            setFormCompletado(false);
            setRespuestaRespt(false);
            setMensajeError(error.response?.data?.error || 'Error desconocido');
        }

    };

    useEffect(() => {
        const enviarFormulario = async () => {
            if (!estadosActualizados || !submitRealizado) return;

            const validacionTodosDatos = todosDatosCorrectos(curso, formData, estadoCampoReque, estadoCampoSintaxis);
            const todosCamposFalse = validacionTodosDatos.todosCamposFalse();

            console.log("todosCamposFalse", todosCamposFalse);
            console.log("captchaToken", captchaToken);
            console.log("estadoCampoReque", estadoCampoReque);
            console.log("estadoCampoSintaxis", estadoCampoSintaxis);

            if (!todosCamposFalse) {
                console.log("Validación falló - campos que faltan:");
                console.log("estadoCampoReque con errores:", Object.entries(estadoCampoReque).filter(([, value]) => value === true));
                console.log("estadoCampoSintaxis con errores:", Object.entries(estadoCampoSintaxis).filter(([, value]) => value === true));
                setSubmitRealizado(null);
                return;
            }

            if (!captchaToken) {
                setMensajeError("Por favor, completa el CAPTCHA.");
                setSubmitRealizado(null);
                return;
            }

            try {
                // Validar CAPTCHA
                const captchaResponse = await fetchCatcha(captchaToken);
                if (!captchaResponse.data.success) {
                    setMensajeError("Validación de CAPTCHA fallida.");
                    setFormCompletado(false);
                    setRespuestaRespt(false);
                    if (recaptchaRef.current) {
                        recaptchaRef.current.reset();
                    }
                    setCaptchaToken(null);
                    setSubmitRealizado(null);
                    return;
                }


                const newData = { ...formData, curso: curso.nombre, plazasAgotadas: curso.plazasAgotadas };
                const response = await fetchCrearCurso(newData);
                
                console.log("Formulario enviado correctamente:", response.data);
                
                setFormCompletado(true);
                setRespuestaRespt(true);
                
                const nuevoFormData = {};
                for (const campo in formData) {
                    nuevoFormData[campo] = '';
                }
                setFormData(nuevoFormData);
                
                if (recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
                setCaptchaToken(null);
                
                // Limpiar inputs de archivo si los hay
                const fileInputs = document.querySelectorAll('input[type="file"]');
                fileInputs.forEach(input => {
                    input.value = "";
                });

                // Volver atrás
                setTimeout(() => {
                    window.history.back();
                }, 2000);

            } catch (error) {
                setFormCompletado(false);
                setRespuestaRespt(false);
                setMensajeError(error.response?.data?.error || 'Error desconocido del servidor');
                
                if (recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
                setCaptchaToken(null);
            }
            setSubmitRealizado(null);
        };

        enviarFormulario();
    }, [estadosActualizados, submitRealizado, captchaToken]);

    //console.log(curso);
    // console.log(formData);


    //console.log("plazasAgotadas",curso.plazasAgotadas);

    return (
        <>
            <DatosCorrectos envioActivado={formCompletado} respuesta={respuestaRespt} />

            <Form >
                <CabeceraForm>
                    {
                        curso.plazasAgotadas == null || curso.plazasAgotadas == 0 ?
                            <TituloForm>FORMULARIO <b>PRE-INSCRIPCIÓN</b></TituloForm>
                            :
                            <>
                                <PlazasAgotadas envioActivado={curso.plazasAgotadas} />
                                <TituloForm>FORMULARIO <b>LISTA ESPERA</b></TituloForm>
                            </>

                    }

                    <Rayita></Rayita>
                    {
                        //Si el curso no tiene subcategoria se motrará el anexo de la primera forma
                        //Y si sí la tiene se mostrará de la segunda forma
                    }


                </CabeceraForm>

                {
                    //Cada campo se compondrá del título, el campo a insertar con su onchange 
                    //que cambiará en base a lo insertado
                    //Y su alert correspondiente el cual por defecto estarán desactivados y se activarán
                    //En cuanto las funciones que detectan los errores detecten algún error
                }

                <Form.Group className="mb-3" controlId="formBasicNameSurname">
                    <TituloCategoria>Nombre y apellidos <span>*</span></TituloCategoria>
                    <Form.Control type="name" name="nombre" value={formData.nombre || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <TituloCategoria>E-mail <span>*</span></TituloCategoria>
                    <Form.Control type="email" name="correo" value={formData.correo || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.correo} estadoAlerta={estadoCampoReque.correo} />
                    <ErrorForm mensaje="Correo erroneo" estadoAlerta={estadoCampoSintaxis.correoMal} />

                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPhone">
                    <TituloCategoria>Telefono <span>*</span></TituloCategoria>
                    <Form.Control type="phone" name="telefono" value={formData.telefono || ''} onChange={handleChange} />
                    <ErrorForm mensaje={camposRequeridos.telefono} estadoAlerta={estadoCampoReque.telefono} />
                    <ErrorForm mensaje="Telefono erroneo" estadoAlerta={estadoCampoSintaxis.telefonoMal} />
                </Form.Group>

                {
                    //Para el listado de provicias descargue la libería doncicuto que me proporciona el listado de provicias
                }
                <Form.Group className="mb-3">
                    <TituloCategoria>
                        Provincia <span>*</span>
                    </TituloCategoria>
                    <Form.Select value={formData.provincia || ''} name="provincia" onChange={handleChange}>
                        <option value="" disabled></option>
                        {provinces
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((provincia, index) => (
                                <option key={index}>{provincia.name}</option>
                            ))}
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.provincia} estadoAlerta={estadoCampoReque.provincia} />
                </Form.Group>


                {
                    //El handleSituacionLaboralChange y handleFuncionarioChange registrán la opcion selecionada
                    //para mostrar los ficheros adjuntos correspondientes
                }
                <Form.Group className="mb-3">
                    <TituloCategoria id="situacionLaboral" >Situación laboral <span>*</span></TituloCategoria>
                    <Form.Select value={formData.situacionLaboral || ''} name="situacionLaboral" onChange={handleChange}>
                        <option value="0"></option>
                        <option value="Desempleado">Desempleado</option>
                        <option value="Trabajador en activo">Trabajador en activo</option>
                        <option value="Erte">Erte</option>
                        <option value="Autónomo">Autónomo</option>
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.situacionLaboral} estadoAlerta={estadoCampoReque.situacionLaboral} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <TituloCategoria>¿Cómo nos has conocido? <span>*</span></TituloCategoria>
                    <Form.Select value={formData.comoNosConociste || ''} name="comoNosConociste" onChange={handleChange}>
                        <option></option>
                        <option value="Google">Google</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <option value="Newsletter">Newsletter</option>
                        <option value="conocidos">Mediante conocidos, compañeros…</option>
                        <option value="Otros">Otros</option>
                    </Form.Select>
                    <ErrorForm mensaje={camposRequeridos.comoNosConociste} estadoAlerta={estadoCampoReque.comoNosConociste} />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                    <Form.Check type="checkbox" >
                        <Form.Check.Input id="checkbox" name="aceptaPoliticaPrivacidad" checked={formData.aceptaPoliticaPrivacidad || ''} onChange={handleChange} />
                        <TituloCheckBox>
                            Acepto y he leído la{" "}
                            <Link to="/politica-de-privacidad" target="_blank" rel="noopener noreferrer">
                                Política de Privacidad
                            </Link>{" "}
                            <span>*</span>
                        </TituloCheckBox>

                    </Form.Check>
                    <ErrorForm mensaje={camposRequeridos.aceptaPoliticaPrivacidad} estadoAlerta={estadoCampoReque.aceptaPoliticaPrivacidad} />
                </Form.Group>

                <ReCAPTCHA
                    sitekey="6LduzrYpAAAAAHZvATEFxjivMSRYdZolVmuAI6Dq"
                    ref={recaptchaRef}
                    size="normal"
                    onChange={(token) => {
                        setCaptchaToken(token);
                        handleChange(null, token);
                    }}
                />
                <ErrorForm mensaje={camposRequeridos.captcha} estadoAlerta={estadoCampoReque.captcha} />


                <Boton as="button" primario="true" type="submit" onClick={handleSubmit} form="true" >Enviar</Boton>
            </Form >
            <DatosIncorrectos envioActivado={formCompletado} />
            <ServerErrorEnvioForm envioActivado={formCompletado} mensajeError={mensajeError} />
            <AcordeonProDatos>

                <CabezeraAcordeon><p>Información sobre protección de datos</p>

                </CabezeraAcordeon >
                <CuerpoAcordeon>
                    <p><strong><em>INFORMACIÓN BÁSICA DE PROTECCIÓN DE DATOS</em></strong><em>:&nbsp;En cumplimiento del deber de informar a los interesados de las circunstancias y condiciones del tratamiento de sus datos y de los derechos que le asisten, ponemos a su disposición la siguiente información. </em></p>
                    <p><strong><em>RESPONSABLE DE TRATAMIENTO</em></strong><em>: LAE Formación Programada, S.L.</em></p>
                    <p><strong><em>FINALIDAD DEL TRATAMIENTO DE SUS DATOS</em></strong><em>:&nbsp;Incluir su candidatura en futuros procesos de selección de la empresa. </em></p>
                    <p><strong><em>CONTACTO DEL DELEGADO DE PROTECCIÓN DE DATOS:</em></strong> <Link to="mailto:dpo@grupolae.net">dpo@grupolae.net</Link></p>
                    <p><strong><em>CONSERVACIÓN DE LOS DATOS:</em></strong><em> Los datos se conservarán durante un plazo de 6 meses desde la recepción del curriculum. Agotado este plazo la empresa destruirá el curriculum al menos que el candidato haya mandado una actualización del mismo.</em></p>
                    <p><strong><em>LEGITIMACIÓN PARA EL TRATAMIENTO</em></strong><em>:&nbsp;Consentimiento explícito otorgado con la aceptación de las condiciones de uso de nuestro formulario.</em></p>
                    <p><strong><em>DESTINATARIOS DE SUS DATOS PERSONALES</em></strong><em>:&nbsp;No se prevén cesiones de datos salvo en aquellos casos en que exista una obligación legal. No hay previsión de transferencias de datos internacionales. En caso de que la empresa envíe su curriculum a un tercero se solicitará formalmente su conformidad.</em></p>
                    <p><strong><em>SUS DERECHOS</em></strong><em>: Puede revocar el consentimiento y ejercer sus Derechos a acceder, rectificar, oponerse, limitar, portar y suprimir los datos, escribiendo a LAE Formación Programada, S.L., en C/ Juan F. Gilisagasti 2 – Oficina 215, 20018 Donostia – San Sebastián (Gipuzkoa), además de la posibilidad de acudir a la autoridad de control competente (AEPD).</em></p>
                    <p><strong><em>INFORMACIÓN ADICIONAL</em></strong><em>:</em> <em>Puede consultar la información adicional y detallada en nuestra <Link to="/politica-de-privacidad" target="_blank" rel="noopener">Política de Privacidad</Link>.</em></p>

                </CuerpoAcordeon>

            </AcordeonProDatos>

        </>
    );
}


const CabeceraForm = styled.div`
    margin-bottom: 10px;
`

const TituloForm = styled.h3`
    color: #000000;
    font-family: "Dosis";
    font-size: 22px;
    font-weight: 400;
    text-transform: uppercase;
    text-align: center;

`

const Rayita = styled.span`
    margin-top: 8% !important;
    margin-bottom: 8% !important;
    width: 31% ;
    margin: 0 auto ;
    border: solid #EE805D;
    display: block;
`

const Anexo = styled.p`
    color: #7A7A7A;
    margin: 0 0 20px;
    font-family: 'Roboto';
    a{
        color:black;
    }

`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span{
        color: #ff0000;
        font-weight: 400;
    }

`
const TituloCheckBox = styled(Form.Check.Label)`
    margin-left: 10px;
    
    a{
        text-decoration: none;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
    }

    a:hover{
        color: #337ab7;
    }

    span{
         color: #ff0000;
        font-weight: 400;
    }
`

const AcordeonProDatos = styled(Accordion)`
    .accordion-button:focus {
    border-color:  rgba(0, 0, 0, 0) !important;
    
    box-shadow:  rgba(0, 0, 0, 0) !important;
    }

    .accordion-button:not(.collapsed) {
    color: rgba(0, 0, 0, 0);
    background-color: rgba(0, 0, 0, 0);
    box-shadow: inset 0 calc(-1* var(--bs-accordion-border-width)) 0 rgba(0, 0, 0, 0);
    }

    
`

const HeaderAcordion = styled(Accordion.Header)`
    p{
        margin-top: 3%;
        margin-right: 15%;
        font-size: 14px;
        color: #EE805D;
    }
    
    
    .accordion-button:not(.collapsed)::before {
    
    transform: rotate(90deg);
    
    }
    .accordion-button::before {
        
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-right: auto;
    content: "";
    
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='rgb(238, 128, 93)' class='bi bi-caret-right-fill' viewBox='0 0 16 16'%3E%3Cpath d='m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: 15px;
    transition: var(--bs-accordion-btn-icon-transition);
    }

    .accordion-button::after {
    display: none;
    }


`
const CabezeraAcordeon = styled(HeaderAcordion)`
    p{
        margin-right: 30% !important;
    }

    @media (max-width: 1250px) {
        p{
        margin-right: 50% !important;
    }
    }
    
`

const CuerpoAcordeon = styled(Accordion.Body)`
color: #7A7A7A;
font-family: 'Roboto';
    a{
        text-decoration: none;
        color: black;
    }
`

export default FormCurso;